'use client';

import {
  NavigationMenu,
  useNavigation,
} from '@wwe-portal/ui/components/navigation';
import { LEADERBOARD_SECTIONS } from '@wwe-portal/web/utils/constants/leaderboard';
import { useScrollOffset } from '@wwe-portal/web/providers/stores/layout-store';

const menuItems = [
  {
    id: LEADERBOARD_SECTIONS.FACTION_BOSS,
    label: 'Faction Boss Results',
  },
  {
    id: LEADERBOARD_SECTIONS.FACTION_FEUD,
    label: 'Faction Feud Results',
  },
];

export const LeaderboardNavigationMenu = () => {
  const scrollOffset = useScrollOffset();
  const { activeId, handleItemClick, lockedActiveId } =
    useNavigation(menuItems);
  return (
    <div
      className="z-sticky data-[sticky=true]:bg-back600 sticky top-[60px] mx-[-20px] px-5 py-5 xl:top-[70px] xl:mx-[-30px] xl:px-[30px]"
      data-sticky={scrollOffset && scrollOffset > 55}
    >
      <NavigationMenu
        activeId={lockedActiveId ?? activeId}
        items={menuItems}
        onClick={handleItemClick}
        className="grid grid-flow-col justify-stretch 2xl:justify-end"
        itemClassName="px-5 xl:text-sm 2xl:text-xs"
      />
    </div>
  );
};
